import { cn } from 'lib/utils'
import * as React from 'react'

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, form, ...props }, ref) => (
    <input
      type={type}
      className={cn(
        'flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-p-400 shadow-none transition-colors file:border-0 file:bg-transparent file:text-p-500 placeholder:text-muted-foreground focus-visible disabled:cursor-not-allowed',
        type === 'number' && 'font-jetbrains tabular-nums tracking-normal',
        className,
      )}
      ref={ref}
      {...props}
    />
  ),
)
Input.displayName = 'Input'

export { Input }
